<template>
    <section class="EcoCommitments" aria-labelledby="eco-title">
      <div class="EcoCommitments__wrap">
        <h2 id="eco-title" class="EcoCommitments__title" :class="isPhone ? 'merriweather-reg-18' : 'merriweather-reg-32'">
          Leur engagement environnemental
        </h2>
  
        <div class="EcoCommitments__track">
          <article
            v-for="(it, i) in normalized"
            :key="i"
            class="EcoCommitments__card"
            :aria-label="it.label || (defaults[it.kind] && defaults[it.kind].label) || ''"
          >
            <span class="EcoCommitments__icon" v-html="icon(it.kind)"></span>
            <p class="EcoCommitments__label raleway-reg-p16">
              {{ it.label || (defaults[it.kind] && defaults[it.kind].label) || '' }}
            </p>
          </article>
        </div>
      </div>
    </section>
  </template>
  
  <script>
  export default {
    name: 'EcoCommitmentsSection',
    props: {
      items: { type: Array, default: () => [] }
    },
    data () {
      return { isPhone: window.innerWidth < 768 }
    },
    computed: {
      normalized () {
        return (this.items || []).slice(0, 4);
      },
      defaults () {
        return {
          biodiversite: {
            label: 'Préservation de la biodiversité et des écosystèmes locaux',
            svg: `
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#2d5f50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <circle cx="32" cy="36" r="20"/>
      <path d="M18 36c7 0 10-10 14-10s7 10 14 10M26 30l-3-6M38 30l3-6M24 42h16"/>
    </g>
  </svg>`
          },
          construction_durable: {
            label: 'Construction économe en énergie et matériaux durables',
            svg: `
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#2d5f50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 44h40V28L32 16 12 28z"/>
      <path d="M26 44V32h12v12"/>
      <path d="M8 48h48"/>
    </g>
  </svg>`
          },
          eclairage_led: {
            label: 'Maîtrise de la consommation énergétique grâce à un éclairage LED responsable',
            svg: `
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#2d5f50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M24 28a8 8 0 1 1 16 0c0 6-6 8-6 12h-4c0-4-6-6-6-12z"/>
      <path d="M28 44h8M26 48h12M30 52h4"/>
      <path d="M32 8v4M16 24h4M44 24h4M20 14l3 3M41 17l3-3"/>
    </g>
  </svg>`
          },
          eau_dechets: {
            label: "Gestion raisonnée de l'eau et réduction des déchets",
            svg: `
  <svg viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg">
    <g fill="none" stroke="#2d5f50" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M32 12c4 8 12 14 12 22a12 12 0 1 1-24 0c0-8 8-14 12-22z"/>
      <path d="M48 28c3 4 6 7 6 12a8 8 0 1 1-16 0"/>
    </g>
  </svg>`
          }
        };
      }
    },
    methods: {
      icon (kind) {
        return (this.defaults[kind] && this.defaults[kind].svg) || '';
      }
    }
  }
  </script>
  
  <style>
  .EcoCommitments {
    background: #f1f6f3;
    padding: clamp(28px, 5vw, 60px) 0;
  }
  .EcoCommitments__wrap {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 clamp(16px, 3vw, 28px);
  }
  .EcoCommitments__title {
    margin: 0 0 clamp(10px, 1.8vw, 14px);
    text-align: center;
    margin: 0 0 clamp(18px, 2.2vw, 28px);
    color: #143d33;
  }
  .EcoCommitments__track {
    display: flex;
    gap: clamp(16px, 4vw, 36px);
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    padding: 6px 2px;
  }
  .EcoCommitments__card {
    scroll-snap-align: start;
    flex: 0 0 260px;
    text-align: center;
    color: #2a4f43;
  }
  .EcoCommitments__icon {
    display: inline-block;
    width: clamp(64px, 10vw, 86px);
    height: clamp(64px, 10vw, 86px);
  }
  .EcoCommitments__icon svg { width: 100%; height: 100%; }
  .EcoCommitments__label {
    margin: 12px auto 0;
    line-height: 1.45;
    max-width: 320px;
  }
  @media (min-width: 900px) {
    .EcoCommitments__track {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 38px 28px;
      overflow: visible;
    }
    .EcoCommitments__card { flex: 0 1 auto; }
  }
  </style>  